import React from "react";
import { Link } from "react-router-dom";
import { reviews } from "./reviewsData";

const ReviewsPage: React.FC = () => (
  <section className="centered-section" style={{ textAlign: 'center' }}>
    <div className="translucent-box">
      <h2 className="main-heading">Customer Reviews</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', alignItems: 'center', margin: '2rem 0' }}>
        {reviews.map((review, index) => (
          <div key={index} className="card">
            <span className="review-text">{review.text}</span>
            <div className="review-author">&mdash; {review.author}</div>
            {review.note && (
              <div className="review-note">
                {review.note}
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="review-cta-section">
        <h3 className="sub-heading" style={{ marginTop: 0 }}>Share Your Experience</h3>
        <p className="centered-paragraph">
          Your feedback helps others discover quality sharpening services. Leaving a Google review is the best way to support a small business — it helps us reach new customers and grow.
        </p>
        <a
          href="https://g.page/r/CXB6rzJaI61ZEBM/review"
          target="_blank"
          rel="noopener noreferrer"
          className="google-review-btn"
        >
          Leave a Google Review
        </a>
        <p className="centered-paragraph" style={{ marginTop: '1.5rem', fontSize: '1rem', opacity: 0.8 }}>
          You can also email your review directly using the address at the bottom of the page. We confirm all reviews with actual customers before posting to ensure authenticity.
        </p>
      </div>
      <Link to="/" className="main-link" style={{ display: 'inline-block', marginTop: '1.5rem' }}>
        Back to home
      </Link>
    </div>
  </section>
);

export default ReviewsPage;
